/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React, { useEffect, useState } from "react";
import * as SC from "./CardHeader.styled";
import { useTranslation } from "react-i18next";

import {
  ModalInviteMemberLD,
  Store__System,
  CustomerSucessController,
  Store__UsersOnline,
  Floating
} from "@talentbait/shared-components";

import logger from "../../../../../utils/LoggerFrontend";

import Share from "../../../../../../images/dataViz/share.svg";
import Print from "../../../../../../images/dataViz/print.svg";
import Dots from "../../../../../../images/dataViz/dots.svg";
import DataVizStore from "../../../../../Stores/DataVizStore";
import { withRefluxStore } from "../../../../../Stores";
import Actions from "../../../../../Actions";

import {
  CopyLink,
  Plus,
  Feedback
} from "../../../../../PagesUser/SelfServiceCampaignCreation/Previews/Svg";
import { withRouter } from "react-router-dom";
import CardHeaderOptions from "./card-header-options/CardHeaderOptions";

const CardHeader = ({
  cardKey = "",
  title,
  channels = [],
  options = [],
  showWinner = false,
  // Store
  organization,
  user,
  userProfile,
  campaignData,
  onlineUsers,
  // Router
  match
}) => {
  const { t } = useTranslation();

  const [roles, setRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  useEffect(() => {
    const loadRolesHandlerFailed = Actions.getAllRoles.failed.listen((err) => {
      logger.debug("error:InviteMembers:getAllRoles:failed", "called...", { err });
    });

    const loadRolesHandler = Actions.getAllRoles.completed.listen((roles) => {
      logger.debug("InviteMembers:getAllRoles:completed", "called...", roles);
      setRoles(roles);
    });

    const completedAddMember = Actions.addTeamMember.completed.listen((orgaId, memberData) => {
      logger.debug("InviteMembers:addTeamMember:completed", "memberData", {
        memberData,
        orgaId
      });

      const { userName = "" } = memberData;
      const { displayName, uid } = user;

      Actions.sendInvite(orgaId, memberData.id, {
        issuerInvite: displayName,
        issuerUserId: uid,
        userName
      });

      if (window.Actions.addNotification) {
        window.Actions.addNotification(
          t("New team member has been added and the invitation email has been sent")
        );
      }

      this.setState({
        showModal: false
      });

      Actions.notifiyEvent({
        eventName: "members",
        text: `➕ Der User *${displayName}* hat den Nutzer mit der E-Mail ${
          memberData.email
        } dem Team *${organization && organization.name}* hinzugefügt`
      });

      CustomerSucessController.send("Invited:Member", {
        memberData
      });
    });

    Actions.getAllRoles();

    return () => {
      loadRolesHandlerFailed();
      loadRolesHandler();
      completedAddMember();
    };
  }, [t]);

  const handleAddMember = (email, level, firstname, lastname, roleName) => {
    const userId = user.uid;
    logger.debug("InviteMembers:handleAddMember", "called", {
      email,
      level,
      firstname,
      lastname,
      id: userId
    });

    Actions.addTeamMember(organization.id, email, level, firstname, lastname, userId, roleName);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    Actions.addNotification(t("Link copied correctly"));
  };

  const formatOnlineMembers = (onlineMembers) => {
    const memberNames = onlineMembers.map((member) => member.userName);
    const allExceptLast = memberNames.slice(0, -1);
    const lastMember = memberNames[memberNames.length - 1];

    if (memberNames.length === 1) {
      return t("{{name}} is online.", { name: memberNames[0] });
    } else {
      return t("{{names}} & {{lastName}} are online.", {
        names: allExceptLast.join(", "),
        lastName: lastMember
      });
    }
  };

  const eventTracking = (eventName, data) => {
    const { orgaId: organizationId } = match.params;
    const { id: campaignId, orgaName: companyName } = campaignData || {};

    CustomerSucessController.send(eventName, {
      ...data,
      organizationId,
      campaignId,
      companyName,
      source: "DataViz"
    });
  };

  const emitIntercomMessage = () => {
    eventTracking("Button Clicked", { intercomMessageOpen: true });

    if (window.Intercom) {
      window.Intercom("showNewMessage", "");
    }
  };

  const openShareButton = () => {
    eventTracking("Button Clicked", { openShare: true });

    setShowOptionsPopup(!showOptionsPopup);
  };

  const openPrint = () => {
    const { orgaId: organizationId } = match.params;
    const { id: campaignId } = campaignData || {};

    eventTracking("Button Clicked", { openPrint: true });

    window.open(`/campaign/metrics-report/interaction/${organizationId}/${campaignId}`, "_blank");
  };

  const openFeedbackButton = () => {
    eventTracking("Button Clicked", { openFeedback: true });

    setShowFeedback(!showFeedback);
  };

  // Filters an array of online members to exclude the current user.
  const onlineMembers = onlineUsers.filter((member) => {
    return member.userId !== userProfile.userId;
  });

  const areMembersOnline = onlineMembers.length > 0;

  return (
    <SC.Wrapper>
      <ModalInviteMemberLD
        allMembers={organization?.members}
        roles={roles || []}
        orgaId={organization?.id}
        showModal={showModal}
        resetShowModal={() => setShowModal(false)}
        handleAddMember={handleAddMember}
      />
      <SC.Title>{t(title)}</SC.Title>
      <CardHeaderOptions
        options={options}
        channels={channels}
        cardKey={cardKey}
        emitEventTracking={eventTracking}
      />
      {showWinner && (
        <SC.WinnerWrapper>
          <SC.WinnerDot />
          <div>{t("Winner")}</div>
        </SC.WinnerWrapper>
      )}
      <SC.Actions>
        <Floating
          placement="bottom"
          open={showOptionsPopup}
          onOpenChange={setShowOptionsPopup}
          trigger={
            <SC.Share onClick={openShareButton}>
              <Share />
            </SC.Share>
          }
          content={
            <SC.TeamPopUp>
              {areMembersOnline && (
                <SC.TeamPopUpItem>
                  <li style={{ lineHeight: "20px" }}>{formatOnlineMembers(onlineMembers)}</li>
                </SC.TeamPopUpItem>
              )}
              <SC.TeamPopUpItem isAdd onClick={() => setShowModal(true)}>
                <li style={{ fontWeight: "600" }}>
                  <Plus />
                  {t("Invite colleagues")}
                </li>
              </SC.TeamPopUpItem>
              <SC.TeamPopUpItem onClick={copyLink}>
                <li style={{ fontWeight: "600" }}>
                  <CopyLink />
                  {t("Copy link")}
                </li>
              </SC.TeamPopUpItem>
            </SC.TeamPopUp>
          }
        />
        <SC.Print onClick={openPrint}>
          <Print />
        </SC.Print>

        <Floating
          placement="bottom"
          open={showFeedback}
          onOpenChange={setShowFeedback}
          trigger={
            <SC.Dots onClick={openFeedbackButton}>
              <Dots />
            </SC.Dots>
          }
          content={
            <SC.TeamPopUp isFeedback={showFeedback}>
              <SC.TeamPopUpItem onClick={emitIntercomMessage}>
                <li style={{ fontWeight: "600" }}>
                  <Feedback />
                  {t("Give us feedback")}
                </li>
              </SC.TeamPopUpItem>
            </SC.TeamPopUp>
          }
        />
      </SC.Actions>
    </SC.Wrapper>
  );
};
export default withRouter(
  withRefluxStore(CardHeader, [DataVizStore, Store__System, Store__UsersOnline])
);
